import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  oversightSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import markAgendaItemCompleteConfirmDialog from '../dialog.markAgendaItemCompleteConfirmDialog';
import editAgendaItemDialog from '../dialog.editAgendaItemDialog';
import addAgendaItemNoteDialog from '../dialog.addAgendaItemNoteDialog';
import attachAgendaItemDialog from '../dialog.attachAgendaItemDialog';
import controller from './subItem.controller';
import directive from './subItem.directive';
import itemContent from '../itemContent';


export default angular.module('app.components.advisory.oversight.subItem', [
  alerts,
  oversightDataService,
  oversightSharedModelService,
  markAgendaItemCompleteConfirmDialog,
  editAgendaItemDialog,
  addAgendaItemNoteDialog,
  attachAgendaItemDialog,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  itemContent,
])
  .directive('subItem', directive)
  .controller('SubItemController', controller)
  .name;

console.log('app.components.advisory.oversight.subItem created');
